import { render, staticRenderFns } from "./ViewDriverDetailModal.vue?vue&type=template&id=dd40958e"
import script from "./ViewDriverDetailModal.vue?vue&type=script&lang=ts"
export * from "./ViewDriverDetailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports